/* ============================================================
 *  alphavital — Predictive Search
 *  Live-Produktvorschläge während des Tippens (Shopify Suggest API).
 *  Kein Framework. Graceful: ohne Treffer/Netz bleibt die normale Suche.
 * ============================================================ */
(function () {
  'use strict';

  function money(value) {
    // Shopify Suggest-API liefert den Preis als Dezimal-String in der Hauptwährungseinheit
    // (z. B. "25.39"), NICHT in Cent — daher hier KEIN /100.
    var num = parseFloat(value);
    if (!isFinite(num)) num = 0;
    try {
      return num.toLocaleString('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    } catch (e) { return num.toFixed(2).replace('.', ',') + ' €'; }
  }

  function debounce(fn, wait) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }

  function init(root) {
    var input = root.querySelector('[data-predictive-input]');
    var results = root.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var controller = null;

    function close() { results.hidden = true; results.innerHTML = ''; }

    function render(products, query) {
      if (!products.length) {
        results.innerHTML = '<div class="psr__empty">Keine Treffer für „' + escapeHtml(query) + '"</div>';
        results.hidden = false;
        return;
      }
      var html = '<ul class="psr__list" role="list">';
      products.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        var price = (typeof p.price !== 'undefined') ? p.price : (p.price_min || 0);
        html += '<li><a class="psr__item" href="' + p.url + '">'
          + (img ? '<span class="psr__thumb"><img src="' + img + '" alt="" loading="lazy"></span>' : '<span class="psr__thumb"></span>')
          + '<span class="psr__info"><span class="psr__title">' + escapeHtml(p.title) + '</span>'
          + '<span class="psr__price">' + money(price) + '</span></span></a></li>';
      });
      html += '</ul>';
      html += '<a class="psr__all" href="/search?q=' + encodeURIComponent(query) + '&type=product">Alle Ergebnisse ansehen</a>';
      results.innerHTML = html;
      results.hidden = false;
    }

    function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

    var search = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, q);
        })
        .catch(function () { /* still: normale Suche bleibt nutzbar */ });
    }, 220);

    input.addEventListener('input', search);
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && results.innerHTML) results.hidden = false; });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
  }

  function boot() {
    document.querySelectorAll('[data-predictive]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
